import { Component, OnInit, ViewChild, ElementRef, OnDestroy,
  Input, ChangeDetectorRef } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { FormGroup } from "@angular/forms";
import { FormValidatorService } from '../../../../../../../shared/services/form-validator.service';
import { Validators } from '../../../../../../../shared/validators';
import { CustomValidators } from '../../../../../../../shared/custom-validators';
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { Ng2ImgMaxService } from "ng2-img-max";
import { UpdateActivationStatusService } from '../../../../../../../shared/services/update-activation-status.service';
import { AuthService } from '../../../../../../../shared/services/auth.service';
import { ActivationStepsService } from '../../../../../../../shared/services/activation-steps.service';
import { ACTIVATION_STEPS } from '../../../../../../../shared/activationSteps';
// Business profile get and post services
import { GetBusinessProfileService } from '../../../../../../../shared/services/get-business-profile.service';
import { UpdateBusinessInfoService } from '../services/update-business-info.service';
import { FetchCategoriesService } from '../services/fetch-categories.service';
import { PostUploadedImageService } from '../services/post-uploaded-image.service';
import { CreditCardReportService } from "src/app/dashboard/admin/request/components/activation/credit-card-requests.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-business-info',
  templateUrl: './business-info.component.html',
  styleUrls: ['./business-info.component.scss']
})
export class BusinessInfoComponent implements OnInit, OnDestroy {
  @ViewChild("tooltip") tooltipBankMessage!: ElementRef;
  @Input() oldValues: any;
  @Input() isAdmin: any;
  @Input() businessId: any;

  logoUrl: string = '';
  profileForm!: FormGroup;
  isVerifed: boolean = false
  categoryOptions: { id: string; name: string }[] = [];
  selectedFile: any;
  imageSrc: any;
  facebookPattern = /^(https?:\/\/)?(www\.)?facebook.com\/[\u0621-\u064A\u0660-\u0669a-zA-Z0-9(\.\?)?]/;
  twitterPattern = /^(https?:\/\/)?(www\.)?twitter.com\/[\u0621-\u064A\u0660-\u0669a-zA-Z0-9(\.\?)?]/;
  linkedInPattern = /^(https?:\/\/)?(www\.)?linkedin.com\/[\u0621-\u064A\u0660-\u0669a-zA-Z0-9(\.\?)?]/;
  facebookStatus:boolean;
  emailStatus:boolean;
  phoneStatus:boolean;
  facebookLikes:number;
  emptyLogo = false;
  notOnlyNumPattern = /(?!^\d+$)^.+$/g;
  OnlyNumPattern = /^\d+$/;
  subscriptions: Subscription[] = [];

  constructor(
    private translate: TranslateService,
    private getBusinessProfile: GetBusinessProfileService,
    private fetchCategories: FetchCategoriesService,
    private update: UpdateBusinessInfoService,
    private puiS: PostUploadedImageService,
    private ng2ImgMax: Ng2ImgMaxService,
    public formValidator: FormValidatorService,
    private auth: AuthService,
    private snackBar: MatSnackBar,
    public sanitizer: DomSanitizer,
    private route: Router,
    public dialog: MatDialog,
    public UpdateActivationStatus: UpdateActivationStatusService,
    public ActivationSteps: ActivationStepsService,
    private cdr: ChangeDetectorRef,
    public withdrawalActivationReportService: CreditCardReportService,
  ) { }

  async ngOnInit() {
    let activationRequestList: {
      result: Array<{
        facebook_verified: number;
        mail_verified: number;
        phone_verified:number;
        bussinesId:number;
        [key: string]: any;
      }>;
    } = await this.withdrawalActivationReportService.make();
    let myActivations: {
      facebook_verified: number;
      mail_verified: number;
      phone_verified:number;
      bussinesId:number;
      [key: string]: any;
    } = activationRequestList.result.filter((res: any) => {
      return res.bussinesId == this.businessId;
    })[0];
    this.facebookStatus = myActivations?.facebook_verified == 1 ? true : false;
    this.emailStatus = myActivations?.mail_verified == 1 ? true : false;
    this.facebookLikes = +myActivations?.facebook_likes;
    this.phoneStatus = myActivations?.phone_verified == 1 ? true : false;

    this.profileForm = this.formValidator.createForm([
      {
        fieldName: "name",
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "Business name"
            })
          },
          {
            validatorFn: Validators.minLength(2),
            message: this.translate.instant("FORMS.VALIDATION.MINIMUM_LENGTH", {
              field: "Business name",
              value: 2
            })
          },
          {
            validatorFn: CustomValidators.customPattern(this.notOnlyNumPattern),
            message: this.translate.instant("FORMS.VALIDATION.NOT_NUMBERS", {
              field: "business name"
            })
          }
        ]
      },
      {
        fieldName: "description",
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.required,
            message: "description cannot be empty"
          }
        ]
      },
      {
        fieldName: "businessLogo",
        defaultValue: null,
      },
      {
        fieldName: "CategoryId",
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.required,
            message: "category cannot be empty"
          }
        ]
      },
      {
        fieldName: "link_fb",
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.pattern(this.facebookPattern),
            message: "not a valid facebook url"
          },
          {
            validatorFn: Validators.required,
            message: "Facebook Profile Link can't be empty"
          }
        ]
      },
      {
        fieldName: "link_tw",
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.pattern(this.twitterPattern),
            message: "not a valid twitter url"
          }
        ]
      },
      {
        fieldName: "link_li",
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.pattern(this.linkedInPattern),
            message: "not a valid linkedIn url"
          }
        ]
      },
      {
        fieldName: 'customPaymentFeesOnBuyer',
        defaultValue: false
      },
      {
        fieldName: "cs_email",
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.email,
            message: "not a valid email format"
          }
        ]
      },
      {
        fieldName: "cs_phone",
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.pattern(this.OnlyNumPattern),
            message: "must be only numbers"
          }
        ]
      },
      {
        fieldName: "referrer_code",
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.pattern(this.OnlyNumPattern),
            message: "must be only numbers"
          }
        ]
      },
    ]);

    const categories = await this.fetchCategories.make();
    this.categoryOptions = categories;

    this.isVerifed = await this.isActiveStatus()
    let oldValues = this.oldValues
      ? this.oldValues
      : await this.getBusinessProfile.make();
    oldValues = oldValues.Seller
      ? oldValues.Seller.Business
      : oldValues.Business;

    if (oldValues?.QassatlyMerchant) {
      // this.businessProfileActions.qassatlyStatus = oldValues.QassatlyMerchant.isEnabled || false;
      // this.businessProfileActions.merchantID = oldValues.QassatlyMerchant.merchant_id || null;
      this.cdr.detectChanges();
    }
    oldValues['customPaymentFeesOnBuyer'] = Boolean(oldValues['customPaymentFeesOnBuyer']);
    Object.keys(this.profileForm.controls).forEach(control => {
      let value = oldValues[control];
      if (control === "referrer_code") {
          value = oldValues?.referee?.[0]?.referrer?.referrer_code;
      }
      this.profileForm.controls[control].setValue(value);
    });

    this.imageSrc = oldValues.logo;
    this.profileForm.valueChanges.subscribe(
      (e) => {
        if(this.formValidator.formGroup != this.profileForm)
          this.formValidator.formGroup = this.profileForm
      }
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subs => subs.unsubscribe());
  }

  onFileInput(event: any) {
    this.selectedFile = <File>event.target.files[0];
    this.subscriptions.push(
      this.ng2ImgMax.compressImage(this.selectedFile, 0.2, true).subscribe(
        (result: any) => {
          this.emptyLogo = false;
          const image = new File([result], result.name);
          this.selectedFile = image;
          this.getImagePreview(image);
        },
        (error: any) => {
          console.log("there is an", error);
        }
      )
    );
  }

  getImagePreview(file: File) {
    const reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.imageSrc = reader.result;
    };
  }

  async onUploadImage() {
    const fd = new FormData();
    fd.append("image", this.selectedFile);
    console.log(fd);
    this.puiS.setParams(fd);
    try {
      return await this.puiS.uploadImage();
    } catch (errors) {
      console.log(errors);
      throw errors;
    }
  }

  // openBankAcountDialog() {
  //   const dialogRef = this.dialog.open(BankAccountComponent);

  //   this.subscriptions.push(dialogRef.afterClosed().subscribe(result => {
  //     console.log(`bank account dialog result: ${result}`);
  //   }));
  // }
  async isActiveStatus() {
    let business = await this.auth.getBusiness();
    if (!business) return false;
    if (business.activeStatus != 'UnVerified') {
      return true;
    }
    return false;
  }

  async onSubmit(profileValues: any) {
    if (this.profileForm.invalid) {
      this.formValidator.forceShowErrors();
      return;
    }
    try {
      if (!this.imageSrc) {
        this.emptyLogo = true;
        return;
      }
      if (this.selectedFile) {
        const uploadResult = await this.onUploadImage();
        console.log(uploadResult);
        profileValues["logo"] = uploadResult.location;
      }

      if (this.isAdmin) {
        profileValues["isAdmin"] = this.isAdmin;
      }

      if (this.businessId) {
        profileValues["businessId"] = this.businessId;
      }

      this.update.setParams(profileValues);
      const updateResult = await this.update.make();
      this.auth.setStatus("active");
      let params = {
        activationStep: ACTIVATION_STEPS.BUSINESS_PROFILE,
        activationStatus: true
      };
      this.UpdateActivationStatus.setParams(params);
      if (!this.isAdmin) {
        let result = await this.UpdateActivationStatus.make();
        if (result.success) {
          this.ActivationSteps.setBusinessProfileStep = params;
        }
      }
      this.snackBar
        .open("updated successfully", "close", { duration: 3000 })
        .afterDismissed()
        .subscribe(() => {
          if(this.isAdmin) this.route.navigate(["/admin/dashboard"]);

        });
    } catch (errors) {
      if (errors.validationErrors?.error) {
        for (const e of errors.validationErrors.error) {
          this.formValidator.addError(e.field, "invalid", e.message);
          this.profileForm.controls[e.field].setErrors({ invalid: e.message });
          this.formValidator.ShowErrors();
        }
      } else {
        const massage = errors.faultyRequest.error?.message;
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: massage ?? errors.faultyRequest.error.error,
        });
      }
    }
  }
}
